import React from 'react'
import env from '../../../core/config/env'
//import TagFunctions from '../../../core/functions/TagFunctions'
import { Container } from '@mui/material'
import { CeletusSellerOnboardingCard } from '../../../components/Product/SellerOnboarding'
import { useAuthContext } from '../../../core/hooks/useAuthContext'

export default function ProductAcceptForm() {
  /*const active = React.useRef(false)

  React.useEffect(() => {
    if (!active.current) {
      active.current = true
      TagFunctions.addScriptHeader(
        `const bodyScript=document.querySelector('body'),hasScript=document.querySelector('#respondi_src');if(!hasScript){const script=document.createElement('script');script.setAttribute("async", "");document.body.appendChild(script),script.id='respondi_src',script.src='https://embed.respondi.app/embed.js';}`
      )
    }
  }, [active])*/

  const { user } = useAuthContext()

  return (
    <Container>
      {/*<div
        data-respondi-container=""
        data-respondi-mode="regular"
        data-respondi-src="https://form.respondi.app/HgsoxJMS"
        data-respondi-width="100%"
        data-respondi-height="85vh"
      ></div>*/}
      <CeletusSellerOnboardingCard
        open={true}
        userName={user?.unique_name || ''}
        supportEmail={env.SUPPORT_EMAIL || ''}
        supportPhoneDisplay={env.SUPPORT_PHONE_DISPLAY || ''}
        supportWhatsAppUrl={env.SUPPORT_WHATSAPP_URL || ''}
        onRequestToSell={async () => {
          // 1) chamar endpoint "seller/request"
          // 2) registrar evento analytics
          // 3) exibir modal/next-step (se quiser)
        }}
      />
    </Container>
  )
}
